import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=8c7323d2&scoped=true"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=8c7323d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7323d2",
  null
  
)

export default component.exports